import {useEffect,useState} from 'react';
// Explicit links override preferences; only deliberate UI changes are saved.
export default function useViewPreference(key,fallback='') {
  const storage=window.SportsHQSettings || window.localStorage;
  const read=()=>{try{return storage.getItem(key) ?? fallback;}catch{return fallback;}};
  const [value,setValue]=useState(read);
  useEffect(()=>{const sync=()=>setValue(read());window.addEventListener('sports-hq-settings-state',sync);window.addEventListener('sports-hq-guest-choice',sync);window.addEventListener('storage',sync);return ()=>{window.removeEventListener('sports-hq-settings-state',sync);window.removeEventListener('sports-hq-guest-choice',sync);window.removeEventListener('storage',sync);};},[key]);
  const save=next=>{storage.setItem(key,next);setValue(next);};
  return [value,save];
}
